'use client'
import type { SelectHTMLAttributes } from 'react'
import { cx } from '../utils'

export function Select({ className, children, ...rest }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select {...rest} className={cx('pxs-focus h-10 w-full rounded-xs border border-line-strong bg-surface px-3 text-[15px] text-ink shadow-[var(--shadow-xs)] transition-colors duration-100 hover:border-accent focus:border-accent focus:shadow-[0_0_0_3px_var(--color-accent-soft)] disabled:bg-sunken disabled:text-ink-3 disabled:shadow-none', className)}>
      {children}
    </select>
  )
}
